import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import { eventid } from "../../../sql/classy/types";
import * as joda from "@js-joda/core";
import { textbox } from "trader.ts/ui.common";
import { renderEditor } from "../groupmessage/editor";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import { rpc } from "trader.ts/network";
import { renderFileInput } from "../../client/fileinput";
import { arrayBufferToBase64Client } from "../../lib/arraybuffertobase64";
import { checkbox } from "../../client/checkbox";
import { only } from "node:test";

export function render(
  opts:
    | { tag: "new"; date: joda.LocalDate }
    | {
        tag: "edit";
        event: {
          id: eventid;
          description: string;
          text: string;
          html: string;
          attachmentname: string | null;
          date: joda.LocalDate;
          only_for_admins_and_teachers: boolean;
        };
      },
): HTMLElement | HTMLElement[] {
  const nameS = new Source(opts.tag === "new" ? "" : opts.event.description);
  const htmlS = new Source(opts.tag === "new" ? "" : opts.event.html);
  const textS = new Source(opts.tag === "new" ? "" : opts.event.text);
  const onlyForAdminsAndTeachersS = new Source(
    opts.tag === "new" ? false : opts.event.only_for_admins_and_teachers,
  );
  const attachmentS: Source<null | {
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  }> = new Source(null);

  async function doSave() {
    const attach = attachmentS.get();
    const id = await rpc(routes.saveEventSpec, undefined, {
      id: opts.tag === "edit" ? opts.event.id : null,
      html: htmlS.get(),
      text: textS.get(),
      description: nameS.get(),
      date: opts.tag === "edit" ? opts.event.date : opts.date,
      only_for_admins_and_teachers: onlyForAdminsAndTeachersS.get(),
      attachment:
        attach === null
          ? null
          : {
              name: attach.name,
              mimetype: attach.mimetype,
              data: arrayBufferToBase64Client(attach.data),
            },
    });
    return {
      tag: "success" as const,
      redirectUrl: routes.editeventRoute.link({ eventid: id }),
      timeout: 1500,
    };
  }

  const dateFormat = joda.DateTimeFormatter.ofPattern("dd/MM/yyyy");

  const editor = renderEditor(htmlS, textS, null);

  return (
    <div className={style.card + style.card_large}>
      <div className={style.equal_columns}>
        <div>{textbox({ source: nameS, label: "Naam" })}</div>
        <div>
          <label>
            <div>{"Datum"}</div>
            <div className={style.input_like}>
              {(opts.tag === "new" ? opts.date : opts.event.date).format(
                dateFormat,
              )}
            </div>
          </label>
        </div>
      </div>

      <div className={style.equal_columns}>
        <section>
          <label>{"Bijlage"}</label>
          {opts.tag === "edit" && opts.event.attachmentname !== null ? (
            <div style="margin-bottom: 8px">
              {"Huidige bijlage" + ": " + opts.event.attachmentname}
            </div>
          ) : (
            <span></span>
          )}
          <div>
            {renderFileInput({
              source: attachmentS,
              accept: "*",
              initiallabel: "Upload bijlage",
              selectedlabel: "Bijlage",
              style: "width: 100%",
            })}
          </div>
        </section>

        <div>
          <label for="">
            {"Publiek"}
            {checkbox({
              source: onlyForAdminsAndTeachersS,
              label: "Evenement alleen voor admins en docenten",
              class: style.checkbox + style.input_like,
            })}
          </label>
        </div>
      </div>

      <section>
        <label>{"Tekst"}</label>
        {editor.buttonSection}
        {editor.editablediv}
      </section>

      <div style="text-align: right">
        {opts.tag === "edit" ? (
          renderDeleteButton({
            label: "Verwijder evenement",
            confirmationLabel: "Ben je zeker dat je dit evenement wilt verwijderen?",
            redirectTo: "/yearcalendar/Admin/_/None",
            doDelete: () =>
              rpc(routes.deleteEventSpec, undefined, {
                eventid: opts.event.id,
              }),
          })
        ) : (
          <span></span>
        )}
        {renderSaveButton({
          save: doSave,
          text: {
            normal: "Sla op",
            success: "Opgeslagen!",
          },
          reload: false,
        })}
      </div>
    </div>
  );
}
